import { gql } from '@apollo/client';

import client from '../../../../core/services/graphql';

const GET_DEMOGRAPHICS_DATA_QUERY = gql`
  query Analytics($projectId: ID!, $segmentId: ID) {
    analytics(projectId: $projectId, segmentId: $segmentId) {
      demographics {
        country {
          label
          qty
        }
        ageRange {
          label
          qty
        }
        exactAge {
          label
          qty
        }
        raceEthnicHeritage {
          label
          qty
        }
        gender {
          label
          qty
        }
        annualHouseholdIncome {
          label
          qty
        }
        jobTitle {
          label
          qty
        }
        industry {
          label
          qty
        }
        seniority {
          label
          qty
        }
        companySize {
          label
          qty
        }
      }
    }
  }
`;

export const getDemographicsByProjectId = async (projectId, segmentId) => {
  const { data } = await client.getClient().query({
    query: GET_DEMOGRAPHICS_DATA_QUERY,
    variables: { projectId, segmentId },
  });

  return data.analytics.demographics;
};
